module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/bars-e298daab638ecab80ffd41126f3ffd98.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/bars.svg
// module id = K4EJ
// module chunks = 24